import { ListItemIcon, ListItemText } from '@mui/material';
import { useRestricted } from '@procureai/permissions-ui';
import { NavSubListItem } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { Link, useMatch } from 'react-router-dom';
import { useAnalytics } from 'use-analytics';

import { NavItemConfig } from '~/common/types/NavItemConfig';

export interface NavSubListItemLinkProps extends NavItemConfig {
  selected?: boolean;
  onClick?: (id: string) => void;
}

export const NavSubListItemLink = ({ Icon, to, upcoming, id, needs, selected, onClick }: NavSubListItemLinkProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Nav' });
  const { track } = useAnalytics();
  const match = useMatch({ path: `${to}`, end: true });
  const hasPermissions = useRestricted(needs);
  const label = t(id);

  if (hasPermissions) {
    const linkProps = to && {
      component: Link,
      to,
    };
    return (
      <NavSubListItem
        {...linkProps}
        selected={selected !== undefined ? selected : !!match}
        onClick={() => {
          track('Nav Drawer Link Click', { name: label });
          if (onClick) {
            onClick(id);
          }
        }}
        disabled={upcoming}
        data-intercom-target={`NavDrawer ${id}`}
      >
        {Icon && (
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
        )}
        <ListItemText primary={label} />
      </NavSubListItem>
    );
  }

  return null;
};
